/**
 * /tenants/$slug/organizations/new — thin route shim (CIAM Slice 10).
 */

import { createFileRoute } from "@tanstack/react-router";
import { CreateOrganizationPage } from "@/features/organizations/pages/create-organization-page";

export const Route = createFileRoute("/_authed/tenants/$slug/organizations/new")({
  component: CreateOrganizationPage,
});
